"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IncludeLowercaseRule", {
  enumerable: true,
  get: function () {
    return _includeLowercase.default;
  }
});
Object.defineProperty(exports, "IncludeNumberRule", {
  enumerable: true,
  get: function () {
    return _includeNumber.default;
  }
});
Object.defineProperty(exports, "IncludeUppercaseRule", {
  enumerable: true,
  get: function () {
    return _includeUppercase.default;
  }
});
Object.defineProperty(exports, "MaxCharactersRule", {
  enumerable: true,
  get: function () {
    return _maxCharacters.default;
  }
});
Object.defineProperty(exports, "MinCharactersRule", {
  enumerable: true,
  get: function () {
    return _minCharacters.default;
  }
});
Object.defineProperty(exports, "MinMaxCharactersRule", {
  enumerable: true,
  get: function () {
    return _minMaxCharacters.default;
  }
});
Object.defineProperty(exports, "NoOuterWhitespaceRule", {
  enumerable: true,
  get: function () {
    return _noOuterWhitespace.default;
  }
});

var _minCharacters = _interopRequireDefault(require("./min-characters"));

var _maxCharacters = _interopRequireDefault(require("./max-characters"));

var _minMaxCharacters = _interopRequireDefault(require("./min-max-characters"));

var _includeNumber = _interopRequireDefault(require("./include-number"));

var _includeUppercase = _interopRequireDefault(require("./include-uppercase"));

var _includeLowercase = _interopRequireDefault(require("./include-lowercase"));

var _noOuterWhitespace = _interopRequireDefault(require("./no-outer-whitespace"));

[_minCharacters.default, _maxCharacters.default, _minMaxCharacters.default, _includeNumber.default, _includeUppercase.default, _includeLowercase.default, _noOuterWhitespace.default].forEach(r => {
  r.isRule = true;
});